export default __webpack_public_path__ + "static/media/vb_7.371ca7ad.jpg";